import { init, RematchRootState, RematchDispatch } from '@rematch/core'
import common from './common'
import bank from './bank'
import authentication from './authentication'
import supplement from './supplement'
import modal from './modal'
import booking from './booking'
import rating from './rating'
import rateplan from './rateplan'
import accommodation from './accommodation'
import checkin from './checkin'
import invoices from './invoices'
import instantAlert from './instantAlert'
//import establishmentCollection from './establishmentCollection'

const models = {
  common,
  bank,
  authentication,
  supplement,
  modal,
  booking,
  rating,
  rateplan,
  accommodation,
  checkin,
  invoices,
  instantAlert
  //establishmentCollection,
}

const store = init({
  models,
})

export type RootState = RematchRootState<typeof models>
export type RootDispatch = RematchDispatch<typeof models>

export default store